import React, { useState, useEffect, useContext } from "react";

const ThemeContext = React.createContext();

export function useTheme() {
  return useContext(ThemeContext);
}

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(getInitial());

  useEffect(() => {
    const writeTheme = () => localStorage.setItem("theme", theme);

    writeTheme();
  }, [theme]);

  function getInitial() {
    const storredTheme = localStorage.getItem("theme");
    if (!storredTheme) {
      const deviceTheme = window.matchMedia(
        "(prefers-color-scheme: dark)"
      ).matches;
      return deviceTheme ? "dark" : "light";
    } else {
      return storredTheme;
    }
  }

  const toggleTheme = () => {
    if (theme === "dark") setTheme("light");
    else setTheme("dark");
  };
  const info = {
    theme,
    toggleTheme,
  };
  return <ThemeContext.Provider value={info}>{children}</ThemeContext.Provider>;
}
